<template>
  <div class="Game">
      <div >
        <img class="title" border="0" src="@/assets/main/interactive/titreChromatose.png" alt="ChromatoseImage"><br><br>
      </div>
      <div>
        <iframe width="550" height="300" src="//www.youtube.com/embed/N1IE2TMibSM?rel=0" frameborder="0" allowfullscreen></iframe>
        <br>
      </div>
      <div class="project">
            <b>Genre: </b><br>Puzzle/Adventure<br>
            <b>Platforms:</b> <br>PC<br>
            <b>Controls:</b> <br>Similar to the arcade game Asteroids<br>
            <b>Role: </b><br>Animator, artist and designer<br>
            <b>Release:</b><br>October 25, 2013<br>
            <b>Programmer:</b><br>Sebastien Charron<br>
            <b>Summary of story:</b><br>Recently, an evil seed landed in the heart of the world of Color. It has begun to corrupt the land and its inhabitants, creating disorder and disharmony.<br>Even you are affected. You are the combined essence of all colors but you are disoriented and  lost. Where are you? What happened? You need to reveal the story and find a way to repair your world.
            Many inhabitants have been lost, absorbed by the Tint, transformed into grotesque, dark, evil blobs. The green world disappeared and the two other worlds are about to collapse. The world has become…Chromatose.<br>
            The challenge in Chromatose lies in the controls. It uses the Asteroids controls: left and right to turn, up to accelerate, and it keeps all of your momentum (until you hit a wall or reach terminal velocity). These controls allow for a very wide variety of challenges, using only a hazard zone.<br><br>
            <b>More info?</b><br>
            <a href="http://www.chromatosegame.net/" target="_blank">
              <div class="chromatoseGameBtn">
                Chromatose Website<br>
              </div>
            </a>
            <br><br>
            <b>System requirements</b><br>
            Operating system Windows 7;  Processeur2Ghz, 6 cœurs, 2 Go RAM; carte vidéo 1024MO
            <br>

        
        <img border="0" src="@/assets/interactive/game/chromatose/chromatoseWeb.png" alt="ChromatoseImage"><br><br>
        <iframe class="vine-embed" src="https://vine.co/v/h5u95uiFBKq/embed/simple" width="550" height="600" frameborder="0"></iframe>

      </div>
  </div>
</template>

<script>
export default {
  name: 'Game',
  props: {
    msg: String
  },
  mounted(){
      let vineVideo = document.createElement('script');
      vineVideo.setAttribute('src', "//platform.vine.co/static/scripts/embed.js");
      document.head.appendChild(vineVideo);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
.title{
    text-align:center;
    }
.Game{
  font-family: 'Roboto', sans-serif;
  padding-right: 10%;
  padding-top: 2%;
}
.title{
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}
.chromatoseGameBtn{
  border: none;
  padding:10px;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: rgb(255, 255, 255);
  background-color: rgb(0, 0, 0);
  border: none;
  border-radius: 3px;
  box-shadow: 0 5px rgb(212, 212, 212);
}

.chromatoseGameBtn:hover{
  background-color:rgb(59, 49, 63);
  box-shadow: 0 5px rgb(255, 94, 94);
}

.chromatoseGameBtn:active{
  animation: animate-shadow;
  transform: translateY(4px);
  box-shadow: 0 0px rgb(255, 94, 94);
}


</style>
